import type { FaireProductEntity } from "../../entity_types/product";

export const p_w5f236w5ka: FaireProductEntity = {
  token: "p_w5f236w5ka",
  type: "product",
  name: "Sundays Are For Football Long Sleeve Romper - Boys Clothing",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/f782e93c03d5c66270999d2d10964185c233edb35fb9f4604608e9681e5caa3e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/340b270ddad5aaddad67de7b069a885518e2f1f96900e9e234d017d1dee34731.jpeg",
    "https://cdn.faire.com/fastly/586e2aea6209f99f977818520693fc8afcff125be218a584c231b65e8d7538d6.jpeg",
    "https://cdn.faire.com/fastly/edc9a9feeb2f7ce982ed917ebd6d06df882988b39e3fd3633cc23b69d34ea77d.jpeg",
  ],
  priceDollars: 16,
  description:
    "Snuggly, sweet, and made for Sunday cuddles, this adorable romper is perfect for cheering right alongside dad.\n\nFeatures:\n * Romper Color: Natural \n * Graphic Color: Brown \n * Material: 100% Cotton. Rib: 93% Cotton/7% Spandex \n * Features: Tagless inside neck label for an itch-free wear; 3 snap closure; cuffed sleeves; trendy bubble style \n * Fit: Infant Unisex \n * Care: Machine washable, tumble dry low, wash with like colors \n\nEach romper is hand pressed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:22.720Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
